import BaseModel from "@/api/models/BaseModel";

/**
 * UserGradeStatus
 */
export default class UserGradeStatus extends BaseModel{
    
    constructor() {
        super();

        this.NOT_ANSWERED = 0;
        this.ANSWERED     = 1;
    }

}